import { constants } from "../../../constants";

export default class GameSpinStart {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _PRAGMATIC_PLAY_handler() {
        /*
        from docs:
            Event Name                      Description
            "spinStarted"                   Player clicks Spin button and reels started spinning
            "gameRoundStarted"              Player clicks Spin                                      <- this one gets voided!
        */

        this.gb.emitters.emit.web.gameSpinEnd();
        this.gb.isSpinning = false;
    }

    EVOUTION_handler(payload) {
        if (payload) {
            if (payload.data.interruptAllowed) {
                this.gb.emitters.emit.web.gameSpinEnd(payload.data);
            } else {
                this.gb.isSpinning = true;
                this.gb.emitters.emit.web.gameSpinStart(payload.data);
            }
        }
    }

    EVO_handler(data) {
        this.gb.isSpinning = true;
        if (data && data.data) {
            this.gb.emitters.emit.web.gameSpinStart(data.data);
        } else {
            this.gb.emitters.emit.web.gameSpinStart();
        }
    }

    SPRIBE_handler(data) {
        this.gb.isSpinning = true;
        if (data && data.data && data.data.bets && data.data.bets.length > 0) {
            this.gb.emitters.emit.web.gameSpinStart(data.data.bets);
        } else {
            this.gb.emitters.emit.web.gameSpinStart();
        }
    }

    DUSO_handler(data) {
        if (data && data.data && data.data.open === true) {
            this.gb.emitters.emit.web.gameSpinStart();
        } else if(data && data.data && data.data.open === false) {
            this.gb.emitters.emit.web.gameSpinEnd();
        }
    }

    _default(data) {
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.wonAmount = 0;
        }
        setTimeout(() => {
            this.gb.isSpinning = true;
        }, 200)
        this.gb.emitters.emit.web.gameSpinStart(data);
    }

    _void() {
        // do nothing
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EVOLUTION:
                event["GAME_LIFECYCLE"] = this.EVOUTION_handler;
                event["GAME_STATE_BETS_CLOSED"] = this.EVO_handler;
                break;
            case constants.PRAGMATIC_PLAY:
                event["gameRoundStarted"] = this._void;
                event["gameRoundStart"] = this._void;  // undocumented ... get triggered also ... strange, im guessing some legacy stuff ...
                event["spinStarted"] = this._default;
                break;
            case constants.F1X2:
                event["play-start"] = this._default;
                break;
            case constants.SLINGO:
                event["gameBusy"] = this._default;
                break;
            case constants.GREENTUBE:
                event["Spinning"] = this._default;
                break;
            case constants.QS:
            case constants.RELAX:
                event["gprg_GameRoundStart"] = this._default;
                break;
            case constants.IGT:
                event["rgs2custWagerStarted"] = this._default;
                break;
            case constants.PNG:
                event["roundStarted"] = this._default;
                break;
            case constants.NETE:
                event["spinStarted"] = this._default;
                break;
            case constants.MGS:
                event["gameBusy"] = this._default;
                break;
            case constants.NEXTGEN:
            case constants.NYXNEXTGEN:
                event["gameAnimationStart"] = this._default;
                break;
            case constants.THUNDER:
                event["roundstarted"] = this._default;
                break;
            case constants.BP:
                event["gameBusy"] = this._default;
                break;
            case constants.AMATIC:
                event["roundStart"] = this._default;
                break;
            case constants.EDICT:
                event["gameRoundStarted"] = this._default;
                break;
            case constants.EZUGI:
                event["round.no_more_bets"] = this._default;
                break;
            case constants.GSPOKER:
           // case constants.GSBINGO:
                event["gameBusy"] = this._default;
                break;
            case constants.BGS:
                event["gameBusy"] = this._default;
                break;
            case constants.RGU:
                event["gameBusy"] = this._default;
                break;
            case constants.RAW:
                event["gameBusy"] = this._default;
                break;
            case constants.HB:
                event["gameBusy"] = this._default;
                break;
            case constants.DGC:
                event["gel.spin.start"] = this._default;
                break;
            case constants.RRG:
                event["ROUND_START"] = this._default;
                break;
            case constants.WD:
                event["WGEAPI.spinStarted"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["ROUND_START"] = this._default;
                break;
            case constants.SPRIBE:
                event["ifc.start.round"] = this.SPRIBE_handler;
                break;
            case constants.HKS:
                event["onRoundStarted"] = this._default;
                break;
            case constants.SYN:
                event["g2p.spinStarted"] = this._default;
                break;
            case constants.KAJ:
                event["game.spin.started"] = this._default;
                break;
            case constants.DUSO:
                event["TICKET"] = this.DUSO_handler;
                break;
            case constants.ISOFT:
                event["ROUND_STARTED"] = this._default;
                break;
            case constants.RST:
                event["gameBusy"] = this._default;
                break;
            case constants.YGG:
                event["spin/start"] = this._default;
                break;
            case constants.PT:
                event["ucip.gameround.g2wGameRoundStartNotification"] = this._default;
                break;
            case constants.NLC:
                event["busy"] = this._default;
                break;
            case constants.HBN:
                // event["spinStarted"] = this._default;
                event["gameBusy"] = this._default;
                break;
            case constants.SPIN:
                event["round_start"] = this._default;
                break;
            case constants.ENDOR:
                event["startGame"] = this._default;
                break;
            case constants.PLS:
                event["mainspin_START"] = this._default;
                break;
            default:
                event["gameSpinStart"] = this._default;
        }

        return event;
    }
}
